import ThumbnailComponent from '72cms-ui/components/table-elements/ThumbnailComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        image: {
            label: 'Image',
            component: ThumbnailComponent,
            variant: 'w50',
        },
        title: {

        },
        link_value: {
            label: 'Link To',
        },
        link_text: {
            label: 'Link Label',
        },
    },
    sortable: [],
    filterable: [],
    defaultItem: {
        activate: true,
    },
    toolbar: ['create'],
    pagination: false,
    searchable: false,
    treeView: false,
    toolbarDisabled: true,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            primary: true,
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.panel-panel_items.js